// アプリでは本文が文書の全体なので、ブランドの色を :root の CSS 変数に置くなど html や body を指す CSS があるが、@scope の中ではそれらに当たらないので閉じ込める先を指すように読み替える
const toScopeSelector = (selector) =>
  selector
    .replace(/(?:html|:root)\s*>?\s*(?=body(?![\w-]))/gi, '')
    .replace(/(^|[\s,>~+(])(?:html|body|:root)(?![\w-])/gi, '$1:scope');

const isScopable = (rule) =>
  rule instanceof CSSStyleRule || rule instanceof CSSGroupingRule;

const scopeStyleRules = (rules) => {
  for (const rule of rules) {
    if (rule instanceof CSSStyleRule) {
      rule.selectorText = toScopeSelector(rule.selectorText);
    } else if (rule instanceof CSSGroupingRule) {
      // @media の中に書いた @keyframes なども、@scope の外へ効くので落とす
      for (let i = rule.cssRules.length - 1; i >= 0; i--) {
        if (!isScopable(rule.cssRules[i])) rule.deleteRule(i);
      }
      scopeStyleRules(rule.cssRules);
    }
  }
};

// @keyframes や @font-face は @scope に閉じ込められず、外に置くと管理画面の同じ名前の定義を上書きするので描かない（保存する HTML には残る）
export const scopeStyle = (css, scopeSelector) => {
  const sheet = new CSSStyleSheet();
  sheet.replaceSync(css);
  scopeStyleRules(sheet.cssRules);
  const scoped = [...sheet.cssRules].filter(isScopable);
  return `@scope (${scopeSelector}) { ${scoped.map((rule) => rule.cssText).join('\n')} }`;
};
